import React from 'react';
import './Orangers.scss';
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import Header from './assets/orangers-header.svg';

const iconStyles = {
  android: {
    height: '36px',
    width: '36px',
    color: '#2ecc71',
  },
  ios: {
    height: '36px',
    width: '36px',
    color: '#2e4053',
  },
};

const Orangers = () => (
  <div className="container">
    <img src={Header} alt="header" className="header" />
    <div className="bottom-container">
      <a href="https://orangers.s3.ap-south-1.amazonaws.com/v4.6.0.apk" className="list-item" rel="noopener noreferrer">
        <AndroidIcon sx={iconStyles.android} />
        <p className="platform-text">Android APK</p>
        <p className="version-text">v4.6.x</p>
      </a>
      <a href="https://apps.apple.com/us/app/o-rangers/id6478600569" className="list-item" target="_blank" rel="noopener noreferrer">
        <AppleIcon sx={iconStyles.ios} />
        <p className="platform-text">IOS App Store</p>
        <p className="version-text">v4.5.x</p>
      </a>
    </div>
  </div>
);

export default Orangers;
